import { render, staticRenderFns } from "./UpdateParticulars.vue?vue&type=template&id=ab4f9a16"
import script from "./UpdateParticulars.vue?vue&type=script&lang=js"
export * from "./UpdateParticulars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports